import React, { useState } from "react";
import { FaPlus, FaMinus, FaQuestionCircle, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const FaqSection = () => {
  const faqsData = SITE_CONTENT.pages?.homePage?.faqs || SITE_CONTENT.pages?.homePage?.faqSection || {};
  const title = faqsData.title || (faqsData.titlePart1 ? `${faqsData.titlePart1} ${faqsData.titlePart2 || ''}` : "Frequently Asked Questions");
  const rawItems = faqsData.items || faqsData.faqs || [];
  const items = rawItems.map((item) => ({
    q: item.q || item.question || "",
    a: item.a || item.answer || "",
  }));
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section className="bg-[#f8f5ee] text-[#1c2e22] py-24 lg:py-32 relative overflow-hidden" id="faq">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#1b4329]/10 text-[#1b4329] text-xs font-bold tracking-[0.25em] uppercase mb-4 border border-[#1b4329]/20">
            Good to Know
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif leading-tight text-[#0a1a0f] mb-4">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] mx-auto mb-6 rounded-full" />
          <p className="text-[#556359] text-base leading-relaxed">
            Everything you need to know about booking Nawabi Caterers for your wedding, reception, corporate or family function.
          </p>
        </div>

        {/* 10 FAQ Accordion Items */}
        <div className="space-y-4">
          {items.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? "bg-white border-[#E8A040] shadow-md"
                    : "bg-white/80 border-[#e3dcd1] hover:border-[#b8731b]/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(idx)}
                  className="w-full p-6 text-left flex items-center justify-between gap-4 cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-base sm:text-lg text-[#0a1a0f] pr-4 leading-snug">
                    {item.q}
                  </span>
                  <div
                    className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 ${
                      isOpen
                        ? "bg-[#0a1a0f] text-[#E8A040] rotate-180"
                        : "bg-[#f0eae0] text-[#0a1a0f]"
                    }`}
                  >
                    {isOpen ? <FaMinus className="w-3 h-3" /> : <FaPlus className="w-3 h-3" />}
                  </div>
                </button>

                {isOpen && (
                  <div className="px-6 pb-6 pt-1 text-sm sm:text-base text-[#526056] leading-relaxed border-t border-[#f4ede3] animate-fadeIn">
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Have more questions helper */}
        <div className="mt-14 p-6 rounded-2xl bg-white border border-[#e2d9cc] flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <FaQuestionCircle className="text-[#E8A040] w-6 h-6 shrink-0" />
            <span className="text-sm font-medium text-[#1c2e22]">
              Have a custom request or specific date in mind?
            </span>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="tel:+919150299336"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1b4329]/10 text-[#1b4329] text-xs font-bold uppercase hover:bg-[#1b4329] hover:text-white transition-colors"
            >
              <FaPhoneAlt className="w-3 h-3" />
              Call Directly
            </a>
            <a
              href="https://wa.me/919150299336?text=Hi%20Nawabi%20Caterers,%20I%20have%20a%20question%20about%20your%20catering%20services."
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#25D366] text-white text-xs font-bold uppercase hover:bg-[#20ba59] transition-colors"
            >
              <FaWhatsapp className="w-3.5 h-3.5" />
              WhatsApp Us
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FaqSection;
